import React from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/styles';
import { colors } from '@skyslope/mache';
import cs from 'classnames';
import { twMerge } from 'tailwind-merge';
import { useDispatch, useShallowSelector } from '@/lib/reduxHooks';
import * as actions from '@/store/applyTemplate/actions';
import type { ITemplateMetadata } from '@/store/templateManagement/types';
import { TemplatesList } from './templates-list';

const useStyles = makeStyles(() => ({
  header: {
    borderBottom: `1px solid ${colors.grey[500]}`,
  },
}));

export interface AppliedTemplate {
  template: string;
  data: {
    document: string;
  };
}

interface TemplatesDrawerProps extends React.ComponentProps<'div'> {
  handleAddTemplate: (template: any, documentId?: string) => void;
  handleRemoveTemplate: (documentId: string) => void;
}

export function TemplatesDrawer(props: TemplatesDrawerProps) {
  const { className, handleAddTemplate, handleRemoveTemplate, ...rest } = props;
  const {
    templates,
    appliedTemplate,
    selectedDocumentId = '',
  } = useShallowSelector((state) => ({
    templates: state.applyTemplate.templates,
    appliedTemplate: state.applyTemplate.appliedTemplates[state.applyTemplate.selectedDocumentId!],
    selectedDocumentId: state.applyTemplate.selectedDocumentId,
  }));

  const classes = useStyles();
  const dispatch = useDispatch();

  function handleSaveTemplate(templateId: string) {
    const template: AppliedTemplate = {
      template: templateId,
      data: { document: selectedDocumentId },
    };

    handleAddTemplate(template, selectedDocumentId);
  }

  function handleSelectTemplate(template: ITemplateMetadata, wasJustSelected: boolean) {
    if (wasJustSelected) {
      dispatch(actions.previewTemplate(template.id));
      handleSaveTemplate(template.id);
    } else {
      dispatch(actions.previewTemplate(undefined));
      handleRemoveTemplate(selectedDocumentId);
    }
  }

  return (
    <div data-spec="templates-list" className={twMerge('TemplatesDrawer', 'flex flex-col h-full', className)} {...rest}>
      <div className={cs('flex items-center pl-4 py-6', classes.header)}>
        <Typography variant="subtitle1">TEMPLATES</Typography>
      </div>

      <TemplatesList
        templates={templates}
        isLoadingTemplates={false}
        selectedTemplate={appliedTemplate?.metadata}
        onSelectTemplate={handleSelectTemplate}
      />
    </div>
  );
}
